// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__C5CO6","notes":"Notes_notes__1G4TO"};